export default __webpack_public_path__ + "static/media/view2_month_country.3b4495d5.csv";